import { twMerge } from 'tailwind-merge';

import { CardProps } from './types';

export const Card = ({ onClick, children, className }: CardProps) => (
  <div
    onClick={onClick}
    className={twMerge(
      'shadow-primary rounded-4xl bg-white p-4 md:rounded-4xl md:p-6',
      className
    )}
  >
    {children}
  </div>
);
